<template>
  <div v-if="toggleShow">
    <div class="tw-document-wrapper z-top controls-background">
      <div>
        <div class="card-header bg-white d-flex justify-content-between align-items-center  pl-3 pr-2">
          <div class="card-title mb-0 d-flex align-items-center">
            <span class="font-weight-bold">{{ `${$t("printDocument.reference")}: ${reference}` }} </span>
          </div>
          <div class="card-title mb-0 d-flex align-items-end">
            <q-icon name="chevron_right" size="20px" @click="toggleShowControls" />
          </div>
        </div>

          <div class="row card-body tw-document-container">
              <div  v-if="isLoading === true" class="tw-global-spinner z-top position-absolute">
                  <q-spinner-facebook size="3em" color="primary" />
              </div>
              <div v-if="isLoading === false" class="col-12"> 
                  <div   v-if="selectedObject && selectedObject.length ===0" class="text-deep-black-4 font-weight-normal mt-3">
                    <span>  {{ $t("order.orderActions.NoDocumentsFound") }}  </span>
                  </div> 
                <div  v-if="selectedObject && selectedObject.length" class="col-12 pr-2 pl-2 pt-2 default-border-radius">
                        <div  v-for="(value, index) in selectedObject" :key="index" class="col-12 p-2 mb-2 custom-border">
                          <div class="row" v-if="value"> 
                                <div  class="col-lg-3 d-flex flex-column">
                                      <span class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.document') }}
                                      </span>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                          {{ value.original_file_name }}
                                        </a>
                                      </span>
                                </div>
                                  <div  class="col-lg-3 d-flex flex-column">
                                      <span class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.type') }}
                                      </span>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                          {{ documentType(value) }}
                                        </a>
                                      </span>
                                </div>
                                 <div  class="col-lg-2 d-flex flex-column">
                                      <span class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.date') }}
                                      </span>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                          {{ getDateFormat(value.created_at) }}
                                        </a>
                                      </span>
                                </div>
                                 <div  class="col-lg-2 d-flex flex-column">
                                      <span class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.user')  }}
                                      </span>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                           {{ value.created_by }}
                                        </a>
                                      </span>
                                </div>

                                <div class="col-lg-2 text-right " >
                              

                                  <q-btn v-if="value" outline class="btn btn-action"
                                      style="margin-right: 0.2em;"
                                        icon="visibility"
                                        @click="viewDocument(value)">
                                  </q-btn>

                                  <q-btn v-if="value" outline class="btn btn-action"
                                      style="margin-right: 0.2em;"
                                        icon="download"
                                        @click="downloadDocument(value)">
                                  </q-btn>

                                  <q-btn v-if="value" 
                                      style="margin-right: 0.2em;" 
                                      outline 
                                      class="btn btn-action" 
                                      icon="print" 
                                      @click="printDocument(value)">
                                  </q-btn>
                                  
                              </div>
                          </div>
                        
                        </div> 
                </div>
              </div>
        </div>  
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { downloadFileName } from "@/utils/download-file-name";
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import moment from "moment";
import { viewDocumentStreamOrder } from "@/commons/index";

@Options({
  components: {
  }
})
export default class DocumentsHistoryDialog extends Vue {
   isLoading : any= true
    //viewDocument = viewDocumentOrder;
    viewDocument = viewDocumentStreamOrder;
   get toggleShow(){
  return store.state.orderModule.showDocumentsHistory
}

  get reference() {
    switch (this.currentRoute) {
      case "order-edit":
        return store.state.orderModule.order?.reference;
      case "TaskDetail":
        return store.state.taskModule.order?.reference;
    }
    return "-";
  }
  get orderId() {
    switch (this.currentRoute) {
      case "order-edit":
        return store.state.orderModule.order?.resourceUid;
      case "TaskDetail":
        return store.state.taskModule.order?.resourceUid;
    }
    return "-";
  }
   getDateFormat(date?: any){
     return moment(date, 'YYYY-MM-DD HH:mm:ss.S').format('DD/MM/YYYY HH:mm') 
  }

  toggleShowControls() {
    return store.dispatch('orderModule/toggleShowDocumentsHistory')
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }
   get selectedObject() {
       return store.state.orderModule && store.state.orderModule.deletedDocuments ? store.state.orderModule.deletedDocuments : []
  }

  documentType(value: any) {
    let relations : any = [];
     if (value?.relations) {
         relations = JSON.parse(value.relations);
     }
       return relations
       && relations[0]
       && relations[0].qualifier
       && relations[0].qualifier.rawValue
       ? relations[0].qualifier.rawValue
       : ""
  }

  async downloadDocument(document: any) {
      await store.dispatch("taskModule/uploadDocumentModule/downloadFile", {
            request: {resourceUid:document.file_resourceuid},
            callback: this.downloadDocumentResponse,
          });
  }

      
  downloadDocumentResponse(response: any) {
      if (response) {
          const {content} = response;
          const linkSource = `data:${response.format};base64,${content}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = downloadFileName(response);
            downloadLink.click();
      }
  }

  async printDocument(document: any) {
    const downloadDocument :any = await new Promise((resolve) => {
              store.dispatch("taskModule/uploadDocumentModule/downloadFile", {
                callback: (res:any) => {
                  resolve(res);
                },
                request: {resourceUid:document.file_resourceuid}
              });
          });
    if (downloadDocument.content) {
          this.printDocumentResonse(downloadDocument)
    }
  }


  printDocumentResonse(documentUploadResponse: any) {
    if (documentUploadResponse) {
      const {content, format} = documentUploadResponse;
      const byteCharacters = atob(content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: format});

            const blobUrl = URL.createObjectURL(blob);

            // Crée dynamiquement un iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            iframe.src = blobUrl;

            iframe.onload = function() {
                iframe?.contentWindow?.focus();
                iframe.contentWindow?.print();

            };
    }
  }
  async created(){
  this.isLoading = true
  await store.dispatch("orderModule/getOrderDeletedDocuments", {
      filter: {
        orderResourceUid: this.orderId
      },
    });
      this.isLoading = false
  }
}
</script>

<style scoped>
.controls-background {
  background-color: white;
  border-radius: 10px;
  -webkit-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  
  overflow-y: auto;
}
.custom-border{
  background: white;
    border: 1px dashed #3699FF;
    border-radius: 8px;
    overflow: hidden;
}

</style>
